
export default function NotFound() {

    return (
        <main style={{ minHeight: "100vh", backgroundColor: "#f8f7f5" }}>

            <div style={{ display: "flex", justifyContent: "center", padding: "24px 16px 8px" }}>
                <div
                    style={{
                        width: "100%",
                        maxWidth: 600,
                        backgroundColor: "white",
                        borderRadius: 12,
                        boxShadow: "0px 7px 7.68px rgba(0, 0, 0, 0.1)",
                        padding: "40px 24px",
                        textAlign: "center",
                    }}
                >
                    <div style={{ fontSize: 48, fontWeight: 700, color: "var(--bs-primary)" }}>404</div>
                    <div style={{ fontSize: 24, fontWeight: 700, marginTop: 8 }}>找不到頁面</div>
                    <div style={{ fontSize: 14, color: "#7A7E80", marginTop: 8 }}>
                        你要前往的頁面不存在，請返回首頁或重新開始預訂。
                    </div>
                </div>
            </div>
        </main>
    );
}